import { render, staticRenderFns } from "./facilty.vue?vue&type=template&id=1a6e55aa&"
import script from "./facilty.vue?vue&type=script&lang=js&"
export * from "./facilty.vue?vue&type=script&lang=js&"
import style0 from "./facilty.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports